(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["batch-two-review"]) return;
  try {
    
(() => {
  const root=document.querySelector('[data-batch-two-review]');
  if(!root) return;
  const key='elite-batch-two-review-v1';
  const cards=[...root.querySelectorAll('[data-review-id]')];
  const progress=root.querySelector('[data-review-progress]');
  const copy=root.querySelector('[data-review-copy]');
  const reset=root.querySelector('[data-review-reset]');
  const editorBase='https://admin.shopify.com/store/jchuw1-1u/themes/160924795029/editor?previewPath=';
  let state={};
  try{state=JSON.parse(localStorage.getItem(key)||'{}');}catch(e){state={};}

  root.querySelectorAll('a[href^="/t/33/"]').forEach((link)=>{
    const path=link.getAttribute('href').replace('/t/33','')||'/';
    link.href=editorBase+encodeURIComponent(path);
  });

  const save=()=>localStorage.setItem(key,JSON.stringify(state));
  const render=()=>{
    const counts={approved:0,changes:0,rejected:0,pending:0};
    cards.forEach((card)=>{
      const id=card.dataset.reviewId;
      const item=state[id]||{status:'pending',note:''};
      counts[item.status]=(counts[item.status]||0)+1;
      card.dataset.reviewStatus=item.status;
      const box=card.querySelector('[data-review-check]');
      const select=card.querySelector('[data-review-status]');
      const display=card.querySelector('[data-review-note-display]');
      box.checked=item.status==='approved';
      select.value=item.status;
      display.textContent=item.note||'No feedback added.';
    });
    progress.textContent=counts.approved+' approved • '+counts.changes+' changes • '+counts.rejected+' not approved • '+counts.pending+' pending';
  };

  cards.forEach((card)=>{
    const id=card.dataset.reviewId;
    const feedback=document.createElement('div');
    feedback.className='review-card__feedback';
    feedback.innerHTML='<label>Review decision</label><select data-review-status><option value="pending">Pending</option><option value="approved">Approved</option><option value="changes">Changes requested</option><option value="rejected">Do not approve</option></select><button type="button" class="button button--secondary" data-review-note-button>Add / Edit feedback</button><div class="review-feedback-display" data-review-note-display>No feedback added.</div>';
    card.insertBefore(feedback,card.querySelector('a.button'));

    const box=card.querySelector('[data-review-check]');
    const select=card.querySelector('[data-review-status]');
    const noteButton=card.querySelector('[data-review-note-button]');

    box.addEventListener('change',()=>{
      state[id]=state[id]||{status:'pending',note:''};
      state[id].status=box.checked?'approved':'pending';
      save();render();
    });
    select.addEventListener('change',()=>{
      state[id]=state[id]||{status:'pending',note:''};
      state[id].status=select.value;
      save();render();
    });
    noteButton.addEventListener('click',()=>{
      state[id]=state[id]||{status:'pending',note:''};
      const next=window.prompt('Feedback for this item:',state[id].note||'');
      if(next===null) return;
      state[id].note=next.trim();
      save();render();
    });
  });

  copy.addEventListener('click',async()=>{
    const groups={approved:[],changes:[],rejected:[],pending:[]};
    cards.forEach((card)=>{
      const id=card.dataset.reviewId;
      const item=state[id]||{status:'pending',note:''};
      const title=card.querySelector('strong').textContent.trim();
      groups[item.status].push('- '+id+': '+title+(item.note?'\n  Feedback: '+item.note:''));
    });
    const out=['ELITE Batch 2 review feedback','','APPROVED ('+groups.approved.length+')',...(groups.approved.length?groups.approved:['- None']),'','CHANGES REQUESTED ('+groups.changes.length+')',...(groups.changes.length?groups.changes:['- None']),'','DO NOT APPROVE ('+groups.rejected.length+')',...(groups.rejected.length?groups.rejected:['- None']),'','PENDING ('+groups.pending.length+')',...(groups.pending.length?groups.pending:['- None'])].join('\n');
    try{await navigator.clipboard.writeText(out);copy.textContent='Feedback copied';setTimeout(()=>copy.textContent='Copy review feedback',1800);}catch(e){window.prompt('Copy this review feedback:',out);}
  });
  reset.addEventListener('click',()=>{state={};localStorage.removeItem(key);render();});
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-fender-finder-compact"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-elite-finder-bar]').forEach((root) => {
    const form=root.querySelector('[data-finder-bar-form]');
    const error=root.querySelector('[data-finder-bar-error]');
    if(!form || !error) return;
    form.addEventListener('submit',(event)=>{
      const loa=Number(new FormData(form).get('loa'));
      if(!loa || loa<15){
        event.preventDefault();
        error.textContent=root.dataset.invalid;
        error.hidden=false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-fender-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-elite-finder-results]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const params = new URLSearchParams(window.location.search);
    const loa = Number(params.get('loa'));
    const boatType = params.get('boat_type') || 'other';
    const beam = params.get('beam') || '';
    const displacement = params.get('displacement') || '';
    const docking = params.get('docking') || '';
    const error = root.querySelector('[data-results-error]');
    const currency = root.dataset.currency || 'USD';
    const form = root.querySelector('[data-finder-page-form]');

    if (form) {
      const fill = (name, value) => {
        const field = form.elements.namedItem(name);
        if (field && value) field.value = value;
      };
      fill('loa', params.get('loa'));
      fill('boat_type', boatType);
      fill('beam', beam);
      fill('displacement', displacement);
      fill('docking', docking);
    }

    const catalog = {};
    root.querySelectorAll('[data-finder-product]').forEach((el) => {
      catalog[el.dataset.sku] = {
        sku: el.dataset.sku,
        title: el.dataset.title,
        url: el.dataset.url,
        priceCents: Number(el.dataset.priceCents || 0),
        variantId: Number(el.dataset.variantId || 0),
        available: el.dataset.available === 'true',
        stockQuantity: Number(el.dataset.stockQuantity || 0),
        inventoryPolicy: (el.dataset.inventoryPolicy || '').toLowerCase(),
        inventoryManaged: el.dataset.inventoryManaged === 'true',
        image: el.dataset.image || '',
        alt: el.dataset.alt || el.dataset.title,
        descriptionHtml: el.dataset.descriptionHtml || ''
      };
    });

    const covers = {};
    root.querySelectorAll('[data-finder-cover]').forEach((el) => {
      covers[el.dataset.forSku] = {
        title: el.dataset.title,
        variantId: Number(el.dataset.variantId || 0),
        priceCents: Number(el.dataset.priceCents || 0),
        available: el.dataset.available === 'true',
        stockQuantity: Number(el.dataset.stockQuantity || 0),
        inventoryPolicy: (el.dataset.inventoryPolicy || '').toLowerCase(),
        inventoryManaged: el.dataset.inventoryManaged === 'true',
        url: el.dataset.url || '',
        image: el.dataset.image || '',
        alt: el.dataset.alt || el.dataset.title,
        descriptionHtml: el.dataset.descriptionHtml || ''
      };
    });

    if (!params.has('loa')) return;

    const rules = [
      { min: 15, max: 20, standard: '2410BLACK1', standardQty: 4, maximum: '3612BLACK1', maximumQty: 4 },
      { min: 20, max: 25, standard: '2412BLACK1', standardQty: 4, maximum: '3612BLACK1', maximumQty: 4 },
      { min: 25, max: 30, standard: '3612BLACK1', standardQty: 4, maximum: '3618BLACK1', maximumQty: 4 },
      { min: 30, max: 35, standard: '3612BLACK1', standardQty: 4, maximum: '4818BLACK1B', maximumQty: 4 },
      { min: 35, max: 40, standard: '4812BLACK1B', standardQty: 4, maximum: '4818BLACK1B', maximumQty: 4 },
      { min: 40, max: 45, standard: '4818BLACK1B', standardQty: 4, maximum: '6018BLACK1', maximumQty: 4 },
      { min: 45, max: 50, standard: '4818BLACK1B', standardQty: 4, maximum: '6018BLACK1', maximumQty: 6 },
      { min: 50, max: 55, standard: '6018BLACK1', standardQty: 6, maximum: '6024BLACK1', maximumQty: 6 },
      { min: 55, max: 60, standard: '6018BLACK1', standardQty: 6, maximum: '6024BLACK1', maximumQty: 6 },
      { min: 60, max: 65, standard: '7218BLACK1', standardQty: 6, maximum: '7224BLACK1', maximumQty: 8 },
      { min: 65, max: 70, standard: '7218BLACK1', standardQty: 6, maximum: '7224BLACK1', maximumQty: 8 },
      { min: 70, max: null, standard: '7224BLACK1', standardQty: 10, maximum: null, maximumQty: null }
    ];

    const typeNames = {
      powerboat: 'Powerboat',
      sailboat: 'Sailboat',
      power_cat: 'Power catamaran',
      sailing_cat: 'Sailing catamaran',
      other: 'Other'
    };
    const displacementNames = {
      not_sure: '',
      light: 'Light displacement',
      typical: 'Typical displacement',
      heavy: 'Heavy displacement'
    };
    const dockingNames = {
      not_sure: '',
      marina: 'Protected marina',
      tight: 'Tight slip / pilings',
      exposed: 'Exposed / rough dock',
      rafting: 'Rafting often'
    };

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    };

    const rule = rules.find((r) => loa >= r.min && (r.max === null || loa < r.max));
    if (!loa || loa < 15 || !rule) {
      error.textContent = root.dataset.invalid;
      error.hidden = false;
      return;
    }

    root.querySelectorAll('[data-entry-content]').forEach((el) => { el.hidden = true; });

    const profile = [];
    profile.push(loa.toFixed(1).replace('.0', '') + ' ft LOA');
    profile.push(typeNames[boatType] || typeNames.other);
    if (beam) profile.push(beam + ' ft beam');
    if (displacementNames[displacement]) profile.push(displacementNames[displacement]);
    if (dockingNames[docking]) profile.push(dockingNames[docking]);
    root.querySelector('[data-profile-summary]').textContent = profile.join(' • ');
    root.querySelector('[data-results-profile]').hidden = false;

    const getRow = (key) => root.querySelector('[data-builder-item="' + key + '"]');
    const getQty = (key) => {
      const input = root.querySelector('[data-builder-qty="' + key + '"]');
      return Math.max(1, Number(input?.value || 1));
    };
    const setQty = (key, quantity) => {
      const input = root.querySelector('[data-builder-qty="' + key + '"]');
      if (input) input.value = String(Math.max(1, Math.round(Number(quantity) || 1)));
    };
    const isSelected = (key) => {
      const checkbox = root.querySelector('[data-builder-select="' + key + '"]');
      return Boolean(checkbox && checkbox.checked && !checkbox.disabled);
    };
    const setRowImage = (holder, product) => {
      if (!holder) return;
      holder.innerHTML = '';
      if (!product || !product.image) return;
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = product.alt || product.title;
      img.loading = 'lazy';
      holder.appendChild(img);
    };

    const configureItem = (key, variantId, priceCents, available, stockQuantity = 0, inventoryPolicy = '', inventoryManaged = false) => {
      const row = getRow(key);
      if (!row) return;
      row.dataset.variantId = String(variantId || 0);
      row.dataset.priceCents = String(priceCents || 0);
      row.dataset.stockQuantity = String(Number.isFinite(Number(stockQuantity)) ? Number(stockQuantity) : 0);
      row.dataset.inventoryPolicy = String(inventoryPolicy || '').toLowerCase();
      row.dataset.inventoryManaged = inventoryManaged ? 'true' : 'false';

      const checkbox = row.querySelector('[data-builder-select]');
      const selectLabel = row.querySelector('.elite-builder-row__select');
      const selectText = selectLabel?.querySelector('span');
      const isSoldOut = Boolean(variantId) && !available;

      if (checkbox) {
        checkbox.disabled = !available || !variantId;
        if (isSoldOut) checkbox.checked = false;
      }

      if (selectText) {
        if (!selectText.dataset.defaultLabel) selectText.dataset.defaultLabel = selectText.textContent.trim();
        selectText.textContent = isSoldOut ? (root.dataset.soldOut || 'Sold out').toUpperCase() : selectText.dataset.defaultLabel;
      }

      const soldOutStatus = selectLabel?.querySelector('[data-sold-out-status]');
      if (soldOutStatus) soldOutStatus.remove();

      row.classList.toggle('is-sold-out', isSoldOut);
    };

    const exceedsAvailableStock = (row) => {
      if (!row || row.hidden) return false;
      if (row.dataset.inventoryManaged !== 'true') return false;
      if (row.dataset.inventoryPolicy === 'continue') return false;
      const stock = Number(row.dataset.stockQuantity || 0);
      const qty = getQty(row.dataset.builderItem);
      return Number.isFinite(stock) && qty > Math.max(0, stock);
    };

    const hasInsufficientStock = (row) => {
      if (!row || !isSelected(row.dataset.builderItem)) return false;
      return exceedsAvailableStock(row);
    };

    const setStockWarning = (row, show) => {
      if (!row) return;
      const quantityWrap = row.querySelector('.elite-builder-row__quantity');
      if (!quantityWrap) return;
      let warning = quantityWrap.querySelector('[data-stock-warning]');
      if (!warning) {
        warning = document.createElement('small');
        warning.className = 'elite-stock-warning';
        warning.dataset.stockWarning = '';
        quantityWrap.appendChild(warning);
      }
      warning.textContent = show ? (root.dataset.notEnoughStock || 'Not Enough Stock') : '';
      warning.hidden = !show;
      row.classList.toggle('is-stock-short', show);
    };

    const setPackage = (kind, sku, qty, selected) => {
      const product = catalog[sku];
      const row = getRow(kind);
      const title = root.querySelector('[data-' + kind + '-title]');
      const unit = root.querySelector('[data-' + kind + '-unit]');
      const total = root.querySelector('[data-' + kind + '-total]');
      const checkbox = root.querySelector('[data-builder-select="' + kind + '"]');

      setQty(kind, qty);
      if (!product) {
        title.textContent = sku || '';
        unit.textContent = root.dataset.unavailable;
        total.textContent = root.dataset.unavailable;
        if (checkbox) checkbox.disabled = true;
        return;
      }

      title.textContent = product.title;
      unit.textContent = money(product.priceCents);
      row.dataset.detailSku = sku;
      row.dataset.detailTitle = product.title;
      row.dataset.detailUrl = product.url;
      row.dataset.detailDescriptionHtml = product.descriptionHtml || '';
      row.dataset.detailPriceCents = String(product.priceCents || 0);
      if (checkbox) checkbox.checked = selected;
      configureItem(kind, product.variantId, product.priceCents, product.available, product.stockQuantity, product.inventoryPolicy, product.inventoryManaged);
      setRowImage(root.querySelector('[data-' + kind + '-image]'), product);
      row.hidden = false;
    };

    setPackage('standard', rule.standard, rule.standardQty, true);

    if (rule.maximum) {
      root.querySelector('[data-maximum-product]').hidden = false;
      root.querySelector('[data-maximum-manual]').hidden = true;
      setPackage('maximum', rule.maximum, rule.maximumQty, false);
    } else {
      root.querySelector('[data-maximum-product]').hidden = true;
      root.querySelector('[data-maximum-manual]').hidden = false;
    }

    let lineSkus;
    if (loa <= 30) {
      lineSkus = ['638ROPEBLACK2'];
    } else if (loa < 40) {
      lineSkus = ['638ROPEBLACK2', '1038ROPEBLACK2'];
    } else if (loa < 55) {
      lineSkus = ['1038ROPEBLACK2', '638ROPEBLACK2'];
    } else {
      lineSkus = ['1038ROPEBLACK2'];
    }

    let dockSkus;
    if (loa <= 50) {
      dockSkus = ['RP2512BLACK1'];
    } else {
      dockSkus = ['RP2512BLACK1', 'RP5058BLACK1'];
    }

    const pump = catalog.PUMPBLACK1B;

    const configureAccessory = (key, product) => {
      const row = getRow(key);
      if (!row) return;

      const checkbox = row.querySelector('[data-builder-select]');
      if (!product) {
        row.hidden = true;
        if (checkbox) {
          checkbox.checked = false;
          checkbox.disabled = true;
        }
        return;
      }

      row.hidden = false;
      row.dataset.detailSku = product.sku;
      row.dataset.detailTitle = product.title;
      row.dataset.detailUrl = product.url;
      row.dataset.detailDescriptionHtml = product.descriptionHtml || '';
      row.dataset.detailPriceCents = String(product.priceCents || 0);

      const detailHolder = row.querySelector('[data-addon-detail]');
      const unitHolder = row.querySelector('[data-addon-unit]');
      const statusHolder = row.querySelector('[data-addon-status]');
      const imageHolder = row.querySelector('[data-addon-image]');

      if (detailHolder) detailHolder.textContent = product.title;
      if (unitHolder) unitHolder.textContent = money(product.priceCents);
      if (statusHolder) statusHolder.textContent = product.available ? '' : root.dataset.unavailable;

      row.classList.toggle('is-unavailable', !product.available);
      configureItem(key, product.variantId, product.priceCents, product.available, product.stockQuantity, product.inventoryPolicy, product.inventoryManaged);
      setRowImage(imageHolder, product);
    };

    configureAccessory('line-primary', catalog[lineSkus[0]]);
    configureAccessory('line-alternate', lineSkus[1] ? catalog[lineSkus[1]] : null);

    configureAccessory('dock-1', catalog[dockSkus[0]]);
    configureAccessory('dock-2', dockSkus[1] ? catalog[dockSkus[1]] : null);
    configureAccessory('dock-3', dockSkus[2] ? catalog[dockSkus[2]] : null);

    configureAccessory('pump', pump);
    setQty('dock-1', 1);
    setQty('dock-2', 1);
    setQty('dock-3', 1);
    setQty('pump', 1);

    const configureCover = (kind, sku) => {
      const key = 'cover-' + kind;
      const row = getRow(key);
      const cover = covers[sku];
      if (!row || !cover || !cover.variantId) {
        if (row) row.hidden = true;
        return;
      }
      row.dataset.coverAvailable = 'true';
      row.dataset.detailSku = 'COVERS';
      row.dataset.detailTitle = cover.title;
      row.dataset.detailUrl = cover.url || '';
      row.dataset.detailDescriptionHtml = cover.descriptionHtml || '';
      row.dataset.detailPriceCents = String(cover.priceCents || 0);
      root.querySelector('[data-cover-title="' + kind + '"]').textContent = cover.title;
      root.querySelector('[data-addon-unit="' + key + '"]').textContent = money(cover.priceCents);
      configureItem(key, cover.variantId, cover.priceCents, cover.available, cover.stockQuantity, cover.inventoryPolicy, cover.inventoryManaged);
      setRowImage(root.querySelector('[data-cover-image="' + kind + '"]'), cover);
    };

    configureCover('standard', rule.standard);
    if (rule.maximum) configureCover('maximum', rule.maximum);

    const updateAddonVisibility = () => {
      const standardCoverRow = getRow('cover-standard');
      const maximumCoverRow = getRow('cover-maximum');
      if (standardCoverRow && standardCoverRow.dataset.coverAvailable === 'true') {
        standardCoverRow.hidden = !isSelected('standard');
        if (standardCoverRow.hidden) standardCoverRow.querySelector('[data-builder-select]').checked = false;
      }
      if (maximumCoverRow && maximumCoverRow.dataset.coverAvailable === 'true') {
        maximumCoverRow.hidden = !isSelected('maximum');
        if (maximumCoverRow.hidden) maximumCoverRow.querySelector('[data-builder-select]').checked = false;
      }
    };

    const syncRecommendations = () => {
      const standardQty = getQty('standard');
      const maximumQty = rule.maximum ? getQty('maximum') : 0;
      let selectedFenders = 0;
      if (isSelected('standard')) selectedFenders += standardQty;
      if (rule.maximum && isSelected('maximum')) selectedFenders += maximumQty;
      const linePackQty = Math.max(1, Math.ceil(selectedFenders / 2));
      setQty('line-primary', linePackQty);
      setQty('line-alternate', linePackQty);
      setQty('cover-standard', standardQty);
      if (rule.maximum) setQty('cover-maximum', maximumQty);
      updateAddonVisibility();
    };

    const updateTotals = () => {
      let grandTotal = 0;
      let stockIssue = false;

      root.querySelectorAll('[data-builder-item]').forEach((row) => {
        const key = row.dataset.builderItem;
        if (!key || row.hidden) return;
        const price = Number(row.dataset.priceCents || 0);
        const qty = getQty(key);
        const rowTotal = price * qty;
        const overStock = exceedsAvailableStock(row);
        const insufficientStock = hasInsufficientStock(row);

        if (key === 'standard' || key === 'maximum') {
          const total = root.querySelector('[data-' + key + '-total]');
          if (total) total.textContent = price ? money(rowTotal) : root.dataset.unavailable;
        } else {
          const total = root.querySelector('[data-addon-total="' + key + '"]');
          if (total) total.textContent = money(rowTotal);
        }

        setStockWarning(row, overStock);
        if (insufficientStock) stockIssue = true;
        if (isSelected(key)) grandTotal += rowTotal;
      });

      root.querySelector('[data-builder-grand-total]').textContent = money(grandTotal);
      const addButton = root.querySelector('[data-add-selected]');
      if (addButton) addButton.disabled = grandTotal <= 0 || stockIssue;
    };

    syncRecommendations();
    updateTotals();
    root.querySelectorAll('[data-results-content]').forEach((el) => { el.hidden = false; });

    root.querySelectorAll('[data-qty-action]').forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.qtyKey;
        const delta = button.dataset.qtyAction === 'increase' ? 1 : -1;
        setQty(key, getQty(key) + delta);
        if (key === 'standard' || key === 'maximum') syncRecommendations();
        updateTotals();
      });
    });

    root.querySelectorAll('[data-builder-qty]').forEach((input) => {
      input.addEventListener('change', () => {
        const key = input.dataset.builderQty;
        setQty(key, input.value);
        if (key === 'standard' || key === 'maximum') syncRecommendations();
        updateTotals();
      });
    });

    root.querySelectorAll('[data-builder-select]').forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const key = checkbox.dataset.builderSelect;

        if (checkbox.checked && (key === 'line-primary' || key === 'line-alternate')) {
          const otherKey = key === 'line-primary' ? 'line-alternate' : 'line-primary';
          const other = root.querySelector('[data-builder-select="' + otherKey + '"]');
          if (other) other.checked = false;
        }

        if (key === 'standard' || key === 'maximum') syncRecommendations();
        updateTotals();
      });
    });

    const detailModal = root.querySelector('[data-product-detail-modal]');
    const detailGallery = root.querySelector('[data-detail-gallery]');
    const detailTitle = root.querySelector('[data-detail-title]');
    const detailPrice = root.querySelector('[data-detail-price]');
    const detailDescription = root.querySelector('[data-detail-description]');

    const buildDetailGallery = () => {
      const sourceImages = Array.from(detailGallery.querySelectorAll('.elite-package-gallery__img'));
      if (!sourceImages.length) return;

      const main = document.createElement('div');
      main.className = 'elite-detail-gallery__main';

      const mainImage = sourceImages[0].cloneNode(true);
      mainImage.className = 'elite-detail-gallery__main-image';
      mainImage.loading = 'eager';
      main.appendChild(mainImage);

      const thumbs = document.createElement('div');
      thumbs.className = 'elite-detail-gallery__thumbs';

      sourceImages.forEach((source, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'elite-detail-gallery__thumb' + (index === 0 ? ' is-active' : '');
        button.setAttribute('aria-label', 'Show image ' + (index + 1));

        const thumb = source.cloneNode(true);
        thumb.className = 'elite-detail-gallery__thumb-image';
        thumb.loading = 'lazy';
        button.appendChild(thumb);

        button.addEventListener('click', () => {
          mainImage.src = source.src;
          if (source.srcset) {
            mainImage.srcset = source.srcset;
          } else {
            mainImage.removeAttribute('srcset');
          }
          if (source.sizes) {
            mainImage.sizes = source.sizes;
          } else {
            mainImage.removeAttribute('sizes');
          }
          mainImage.alt = source.alt || detailTitle.textContent || '';

          thumbs.querySelectorAll('.elite-detail-gallery__thumb').forEach((item) => {
            item.classList.remove('is-active');
          });
          button.classList.add('is-active');
        });

        thumbs.appendChild(button);
      });

      detailGallery.innerHTML = '';
      detailGallery.appendChild(main);
      if (sourceImages.length > 1) detailGallery.appendChild(thumbs);
    };

    const openDetails = (key, clickedTitle = '') => {
      const row = getRow(key);
      if (!row || !detailModal) return;
      const sku = row.dataset.detailSku || '';
      detailGallery.innerHTML = '';
      const product = catalog[sku] || null;
      const visibleRowTitle =
        row.querySelector('[data-standard-title]')?.textContent?.trim() ||
        row.querySelector('[data-maximum-title]')?.textContent?.trim() ||
        row.querySelector('[data-addon-detail]')?.textContent?.trim() ||
        row.querySelector('[data-cover-title]')?.textContent?.trim() ||
        row.querySelector('h3')?.textContent?.trim() ||
        '';
      const visibleTitle = clickedTitle || visibleRowTitle || product?.title || row.dataset.detailTitle || 'Product details';
      detailTitle.textContent = visibleTitle;
      detailTitle.hidden = false;
      detailTitle.style.display = 'block';
      detailPrice.textContent = money(Number(row.dataset.detailPriceCents || 0));
      detailDescription.innerHTML = row.dataset.detailDescriptionHtml || '';

      const template = root.querySelector('[data-finder-gallery-template][data-sku="' + sku + '"]');
      if (template) {
        detailGallery.appendChild(template.content.cloneNode(true));
        buildDetailGallery();
      }

      detailModal.showModal();
      requestAnimationFrame(() => {
        detailTitle.textContent = visibleTitle;
        detailTitle.hidden = false;
        detailTitle.style.display = 'block';
      });
    };

    root.querySelectorAll('[data-open-detail]').forEach((button) => {
      button.addEventListener('click', () => {
        const row = button.closest('[data-builder-item]');
        const clickedTitle =
          row?.querySelector('[data-standard-title]')?.textContent?.trim() ||
          row?.querySelector('[data-maximum-title]')?.textContent?.trim() ||
          row?.querySelector('[data-addon-detail]')?.textContent?.trim() ||
          row?.querySelector('[data-cover-title]')?.textContent?.trim() ||
          row?.querySelector('h3')?.textContent?.trim() ||
          '';
        openDetails(button.dataset.openDetail, clickedTitle);
      });
    });

    detailModal?.addEventListener('click', (event) => {
      if (event.target === detailModal) detailModal.close();
    });

    const addSelected = root.querySelector('[data-add-selected]');
    addSelected?.addEventListener('click', async () => {
      const aggregated = new Map();
      const selectedRows = Array.from(root.querySelectorAll('[data-builder-item]')).filter((row) => !row.hidden && isSelected(row.dataset.builderItem));
      const stockIssue = selectedRows.some((row) => hasInsufficientStock(row));

      if (stockIssue) {
        selectedRows.forEach((row) => setStockWarning(row, hasInsufficientStock(row)));
        error.textContent = root.dataset.notEnoughStock || 'Not Enough Stock';
        error.hidden = false;
        updateTotals();
        return;
      }

      root.querySelectorAll('[data-builder-item]').forEach((row) => {
        const key = row.dataset.builderItem;
        if (!key || row.hidden || !isSelected(key)) return;
        const id = Number(row.dataset.variantId || 0);
        const quantity = getQty(key);
        if (!id || !quantity) return;
        aggregated.set(id, (aggregated.get(id) || 0) + quantity);
      });

      const items = Array.from(aggregated, ([id, quantity]) => ({ id, quantity }));
      if (!items.length) return;

      const original = addSelected.textContent;
      addSelected.disabled = true;
      addSelected.textContent = root.dataset.addSuccess;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart');
        window.location.href = window.Shopify.routes.root + 'cart';
      } catch (e) {
        addSelected.disabled = false;
        addSelected.textContent = original;
        error.textContent = root.dataset.cartError;
        error.hidden = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
